

exports.__esModule = true;
exports.$GetPSBOffersModel = exports.$GetOfferProgramModel = exports.$CreateOfferModel = exports.$EvaluateCheckoutOfferEligibilityModel = undefined;

var _squid = require('squid');

var $EvaluateCheckoutOfferEligibilityModel = exports.$EvaluateCheckoutOfferEligibilityModel = _squid.$Model.extend('$EvaluateCheckoutOfferEligibilityModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/evaluate-eligibility',
        postAttempts: 1
    }),

    isEligible: function isEligible() {
        return Boolean(this.eligible);
    },
    getCurrencyCode: function getCurrencyCode() {
        return this.currency_code;
    },
    getOfferProgramCode: function getOfferProgramCode() {
        return this.offer_program_code;
    },
    getOfferProgramID: function getOfferProgramID() {
        return this.offer_program_id;
    },


    // This is of the form $5.00
    getOfferValue: function getOfferValue() {
        return this.offer_value;
    }
});

var $CreateOfferModel = exports.$CreateOfferModel = _squid.$Model.extend('$CreateOfferModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/new',
        postAttempts: 1
    }),

    createdOffer: function createdOffer() {
        return Boolean(this.offer_id);
    },
    getOfferAmountLowestDenom: function getOfferAmountLowestDenom() {
        if (!this.createdOffer() || !this.computation_rules) {
            return;
        }

        return _squid.$util.getProperty(this.computation_rules[0], 'offer_value.value');
    },
    getTxnMinimumLowestDenom: function getTxnMinimumLowestDenom() {
        if (!this.createdOffer()) {
            return;
        }

        return _squid.$util.getProperty(this, 'offer_program_info.applicability_rule.cart_rule.min_cart_total');
    }
});

var $GetOfferProgramModel = exports.$GetOfferProgramModel = _squid.$Model.extend('$GetOfferProgramModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/program'
    }),

    getOfferCurrencyCode: function getOfferCurrencyCode() {
        return _squid.$util.getProperty(this, 'currency_code');
    },


    // NOTE this is in the lowest denominator of the currency
    // For example, $5.00 USD would be returned as 500
    getOfferValueLowestDenom: function getOfferValueLowestDenom() {
        return _squid.$util.getProperty(this.computation_rules[0], 'offer_value.value') || 0;
    },
    getMinCartTotalLowestDenom: function getMinCartTotalLowestDenom() {
        return _squid.$util.getProperty(this, 'applicability_rule.cart_rule.min_cart_total') || 0;
    },
    isUserInApplicableCountry: function isUserInApplicableCountry(userCountry) {
        if (!userCountry) {
            return false;
        }

        var applicableCountries = _squid.$util.getProperty(this, 'applicability_rule.user_rule.user_countries') || [];

        return applicableCountries ? applicableCountries.indexOf(userCountry) >= 0 : false;
    }
});

var $GetPSBOffersModel = exports.$GetPSBOffersModel = _squid.$Model.extend('$GetPSBOffersModel', {
    api: new _squid.$Api({
        uri: '/api/checkout/offers/offers'
    }),

    // If an offer is returned in the resource_list, it is active; in this
    // case we do not want to give the user another incentive
    hasActiveOffer: function hasActiveOffer() {
        return Boolean(this.resource_list && this.resource_list.length);
    },


    // Check if the user has an offer belonging to this specific offer program
    hasActiveCheckoutIncentive: function hasActiveCheckoutIncentive(offer_program_id) {
        return offer_program_id && this.hasActiveOffer() && this.resource_list.some(function (offer) {
            return offer.offer_program_id === offer_program_id;
        });
    },


    // Check if the user has an offer with the passed in redemption code
    // NOTE this is necessary because planning does not return which program
    // an incentive is from if the incentive is being used in the transaction.
    // The only identifier is the redemption code
    hasOfferWithRedemptionCode: function hasOfferWithRedemptionCode(redemption_code) {
        return redemption_code && this.hasActiveOffer() && this.resource_list.some(function (offer) {
            return offer.redemption_code === redemption_code;
        });
    }
});

angular.value("$EvaluateCheckoutOfferEligibilityModel", $EvaluateCheckoutOfferEligibilityModel);
angular.value("$CreateOfferModel", $CreateOfferModel);
angular.value("$GetOfferProgramModel", $GetOfferProgramModel);
angular.value("$GetPSBOffersModel", $GetPSBOffersModel);
_squid.$Model;

_squid.$Api;

_squid.$util;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/checkoutIncentive/index.js
// module id = ../node_modules/xo-models/src/checkoutIncentive/index.js
// module chunks = 0